import { useMemo } from 'react';

import * as tracking from './tracking';
import { useApplicationContext } from '../applicationContext';
import { useDeviceType } from '@cian/ui-kit';

import {
  IOfferForTrackOnClickButton,
  IOffersForShowMultiOffers,
  IOffersForShowOffers,
  TRedirectForAnalytics,
} from './types';

import { replaceUndefinedWithNull } from '../common/replaceUndefinedWithNull';

export const useTracking = () => {
  const deviceType = useDeviceType();
  const {
    custom: { userId },
  } = useApplicationContext();

  return useMemo(() => {
    const pageProps = { deviceType, userId };

    const trackClickOnTargetButton = () => {
      tracking.trackClickOnTargetButton(pageProps);
    };

    const trackEditFormValues = (userInput: Record<string, string | undefined | null | number>) => {
      const formData = replaceUndefinedWithNull(userInput);

      tracking.trackEditFormValues({ ...pageProps, userInput: formData });
    };

    const trackClickOnMoreFilters = () => {
      tracking.trackClickOnMoreFilters(pageProps);
    };

    const trackClickOnOfferButton = (offer: IOfferForTrackOnClickButton | null) => {
      tracking.trackClickOnOfferButton({ ...pageProps, offer });
    };

    const trackShowOffers = (offers: IOffersForShowOffers) => {
      tracking.trackShowOffers({ ...pageProps, offers });
    };

    const trackShowMultiOffers = (bank: string, offers: IOffersForShowMultiOffers) => {
      tracking.trackShowMultiOffer({ ...pageProps, offers, bank });
    };

    const trackClickOpenMultiOffer = () => {
      tracking.trackClickOpenMultiOffer(pageProps);
    };

    const trackOpenPhoneAuthModal = () => {
      tracking.trackOpenPhoneAuthModal(pageProps);
    };

    const trackOpenSmsAuthModal = () => {
      tracking.trackOpenSmsAuthModal(pageProps);
    };

    const trackClickOnRepeatSms = () => {
      tracking.trackClickOnRepeatSms(pageProps);
    };

    const trackClickConfirmPhone = () => {
      tracking.trackClickConfirmPhone(pageProps);
    };

    const trackAgreeToCommercial = () => {
      tracking.trackAgreeToCommercial(pageProps);
    };

    const trackClickConfirmSms = () => {
      tracking.trackClickConfirmSms(pageProps);
    };

    const trackRedirect = (bank: string | null, type: TRedirectForAnalytics | null) =>
      tracking.trackRedirect({ ...pageProps, bank, type });
    const trackAuthorizationSuccess = () => tracking.trackAuthorizationSuccess(pageProps);

    return {
      trackClickOnTargetButton,
      trackEditFormValues,
      trackClickOnMoreFilters,
      trackClickOnOfferButton,
      trackShowOffers,
      trackShowMultiOffers,
      trackClickOpenMultiOffer,
      trackRedirect,
      trackAuthorizationSuccess,
      trackOpenPhoneAuthModal,
      trackOpenSmsAuthModal,
      trackClickOnRepeatSms,
      trackClickConfirmPhone,
      trackAgreeToCommercial,
      trackClickConfirmSms,
    };
  }, [deviceType, userId]);
};
